import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { useMemo } from 'react';
import { isSafari } from '../../../utils/browser.esm.js';
import { pick, EMPTY_OBJECT } from '../../../utils/object.esm.js';
import { BoxPrivate } from '../box/box.esm.js';

var _excluded = ["a11yId", "a11yLabel", "after", "afterProps", "autoComplete", "before", "beforeProps", "className", "defaultValue", "disableBorderEffect", "disabled", "height", "hidableTags", "inline", "isLoading", "isRequired", "maskOptions", "message", "messageTextProps", "mode", "onChange", "placeholder", "readOnly", "rootComponent", "rootProps", "showFocusStyle", "size", "state", "sx", "tagsVariant", "type", "value", "variant", "name", "color", "autoWidthPadding", "hiderErrorIcon"];
var useExtractProps = function useExtractProps(props) {
  return useMemo(function () {
    var a11yId = props.a11yId,
      a11yLabel = props.a11yLabel,
      after = props.after,
      _props$afterProps = props.afterProps,
      afterProps = _props$afterProps === void 0 ? EMPTY_OBJECT : _props$afterProps,
      _props$autoComplete = props.autoComplete,
      autoComplete = _props$autoComplete === void 0 ? 'off' : _props$autoComplete,
      before = props.before,
      _props$beforeProps = props.beforeProps,
      beforeProps = _props$beforeProps === void 0 ? EMPTY_OBJECT : _props$beforeProps,
      className = props.className,
      defaultValue = props.defaultValue,
      disableBorderEffect = props.disableBorderEffect,
      disabled = props.disabled,
      _props$height = props.height,
      height = _props$height === void 0 ? '2em' : _props$height,
      hidableTags = props.hidableTags,
      inline = props.inline,
      isLoading = props.isLoading,
      isRequired = props.isRequired,
      maskOptions = props.maskOptions,
      message = props.message,
      messageTextProps = props.messageTextProps,
      mode = props.mode,
      onChange = props.onChange,
      placeholder = props.placeholder,
      readOnly = props.readOnly,
      _props$rootComponent = props.rootComponent,
      Component = _props$rootComponent === void 0 ? BoxPrivate : _props$rootComponent,
      _props$rootProps = props.rootProps,
      rootProps = _props$rootProps === void 0 ? EMPTY_OBJECT : _props$rootProps,
      showFocusStyle = props.showFocusStyle,
      size = props.size,
      state = props.state,
      _props$sx = props.sx,
      sx = _props$sx === void 0 ? EMPTY_OBJECT : _props$sx,
      tagsVariant = props.tagsVariant,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      valueProp = props.value,
      variant = props.variant,
      _props$name = props.name,
      name = _props$name === void 0 ? isSafari ? '__search__' : undefined : _props$name,
      color = props.color,
      autoWidthPadding = props.autoWidthPadding,
      hiderErrorIcon = props.hiderErrorIcon,
      rest = _objectWithoutProperties(props, _excluded);
    var maxWidthProps = _objectSpread2(_objectSpread2({}, pick(props, ['maxWidth'])), pick(sx, ['maxWidth']));
    return {
      a11yId: a11yId,
      a11yLabel: a11yLabel,
      after: after,
      afterProps: afterProps,
      autoComplete: autoComplete,
      before: before,
      beforeProps: beforeProps,
      className: className,
      Component: Component,
      defaultValue: defaultValue,
      disableBorderEffect: disableBorderEffect,
      disabled: disabled,
      height: height,
      hidableTags: hidableTags,
      inline: inline,
      isLoading: isLoading,
      isRequired: isRequired,
      maskOptions: maskOptions,
      message: message,
      messageTextProps: messageTextProps,
      mode: mode,
      onChange: onChange,
      placeholder: placeholder,
      readOnly: readOnly,
      rootProps: _objectSpread2(_objectSpread2({}, maxWidthProps), rootProps),
      showFocusStyle: showFocusStyle,
      size: size,
      state: state,
      sx: sx,
      tagsVariant: tagsVariant,
      type: type,
      valueProp: valueProp,
      variant: variant,
      name: name,
      color: color,
      autoWidthPadding: autoWidthPadding,
      hiderErrorIcon: hiderErrorIcon,
      rest: rest
    };
  }, [props]);
};

export default useExtractProps;
//# sourceMappingURL=use-extract-props.esm.js.map
